module.exports = __webpack_public_path__ + "media/assets/icons/icon_point-0c0be0528a21de39c045b3c950d0d24a.svg";